module.exports = __webpack_public_path__ + "img/Bachelor-microtechnique-8204.609d0026.jpg";